export const formatResponseError = error => {
  if (Array.isArray(error?.errors)) return error?.errors?.map(e => e.message)
  else return [error?.message] || ['Network error or Server is unreachable']
}
